import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import villagemilkLogo from "../../assets/vm.png";
import xploLogo from "../../assets/xplologo.png";
import kdcplLogo from "../../assets/kdcpl.png";
import appolloLogo from "../../assets/appllo.png";

const ClientAnimation = ({ isVisible, isHovered }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [positions] = useState([
    { top: "top-right", bottom: "bottom-left" },
    { top: "top-left", bottom: "bottom-right" }
  ]);

  const clients = [
    { logo: villagemilkLogo },
    { logo: xploLogo },
    { logo: kdcplLogo },
    { logo: appolloLogo }
  ];

  useEffect(() => {
    if (!isVisible || isHovered) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % positions.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [isVisible, isHovered, positions.length]);

  if (!isVisible) return null;

  const currentPositions = positions[currentIndex];
  const topClient = clients[currentIndex * 2 % clients.length];
  const bottomClient = clients[(currentIndex * 2 + 1) % clients.length];

  return (
    <>
      <AnimatePresence mode="wait">
        <motion.div
          key={`top-client-${currentIndex}`}
          className={`client-badge ${currentPositions.top}`}
          initial={{ opacity: 0, y: -50, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.8 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          <div className="client-logo-container">
            <img 
              src={topClient.logo} 
              alt="Client logo"
              className="client-logo-img"
            />
            <div className="underline1"></div>
          </div>
        </motion.div>
      </AnimatePresence>

      <AnimatePresence mode="wait">
        <motion.div
          key={`bottom-client-${currentIndex}`}
          className={`client-badge ${currentPositions.bottom}`}
          initial={{ opacity: 0, y: 50, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -50, scale: 0.8 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          <div className="client-logo-container">
            <img 
              src={bottomClient.logo} 
              alt="Client logo"
              className="client-logo-img"
            />
            <div className="underline1"></div>
          </div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};

export default ClientAnimation;